import { AxiosInstance } from "axios"
import { GuestInfo } from "./guestListTypes"

export enum ServiceCenterGuestListQuery {
    SERVICE_CENTER_GUEST_LIST = "SERVICE_CENTER_GUEST_LIST",
}

type ServiceCenterGuestListParams = Readonly<{
    serviceCenterId: number
    startDate: string
    endDate: string
    state?: string
}>

export type ServiceCenterGuestListResponse = Readonly<{
    guests: Array<GuestInfo>
}>

export async function fetchGuests(
    params: ServiceCenterGuestListParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceCenterGuestListResponse> {
    const { serviceCenterId, ...rest } = params
    const url = `/serviceCenters/${serviceCenterId}/guests`

    const { data } = await axios.get(url, {
        signal,
        params: {
            ...rest,
        },
    })

    return data
}
